import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch, { ExtendedCacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { CheckInStatusResponse } from "./type.ts";

export const useCheckInStatus = () => {
  const { token } = useAuth();

  const fetch = useFetch();

  const { data, isFetching, isError, error } = useQuery<
    CheckInStatusResponse | null,
    Error,
    CheckInStatusResponse
  >({
    queryKey: ["checkInStatus"],
    queryFn: () =>
      fetch<CheckInStatusResponse>(Urls.CheckInStatus, {
        method: "GET",
      }, true, token),
    gcTime: ExtendedCacheTime,
    staleTime: ExtendedCacheTime,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting check-in status");
    }
  }, [error?.message, isError]);

  return {
    data,
    isFetching,
  };
};
